<template>
    <div id="contenedor-listado-tipos-documentos-mobiles">
        <template
            v-for="(tipoDocumento, index) in listadoTiposDocumentos">
            <v-card
                :key="index"
                class="mb-2">
                <v-card-title
                  class="justify-space-between">
                  <div
                    class="d-inline-block text-truncate">
                    {{ tipoDocumento.descripcion }}
                  </div>
                  <div
                    class="d-inline-block">
                    <opciones
                      :tipoDocumento="tipoDocumento">
                    </opciones>
                  </div>
                </v-card-title>
                <v-card-text>
                    Orden: {{ tipoDocumento.orden }}
                </v-card-text>
            </v-card>
        </template>
    </div>
</template>

<script>
import Opciones from './Opciones.vue';

export default {
  name: 'ListadoTiposDocumentosMobiles',
  props: {
    listadoTiposDocumentos: {
      type: Array,
      required: true,
    },
  },
  components: {
    Opciones,
  },
  data() {
    return {
    };
  },

};
</script>

<style lang="scss">

</style>
